import * as Yup from 'yup';
import moment from 'moment';

// https://github.com/jquense/yup/issues/59#issuecomment-259947426

Yup.addMethod(Yup.mixed, 'momentDate', function testDate() {
  return this.test({
    name: 'momentDate',
    exclusive: true,
    message: 'Must be a valid date',
    test: (value) => {
      try {
        // console.devLog.info('date value test?', value);
        return moment(value).isValid();
      } catch (e) {
        // console.devLog.info(`Date validation error ${e}`);
        return false;
      }
    },
  });
});
